<template>
    <div>
        <div class="custom-select-simple" v-if="simpleSelect">
            <div class="custom-select-simple--item" :class="{'selected-border': getSelected(option)}" v-for="(option, index) in options" :key="index" @click="selectItem(option)">
                <component class="custom-select-simple--item--image" v-if="option.icon" :is="option.icon" width="40px" height="40px" :fillColor="selectedOption === index ? '#52755C' : ''"/>
                <p class="custom-select-simple--item--text" :class="{selected: getSelected(option)}" v-if="option.name">{{option.name}}</p>
            </div>
        </div>
        <div v-if="!simpleSelect" class="custom-select">
            <div v-for="(option, index) in options" :key="index" @click="selectItem(option)">
                <custom-select-item :option="option" :trackBy="trackBy" :selectedOption="selectedOption"/>
            </div>
        </div>
    </div>
</template>

<script>
import CustomSelectItem from '@/components/partials/register/CustomSelectItem';
import House from '@/assets/images/pages/checkout/House';
import Flat from '@/assets/images/pages/checkout/Flat';
import Office from '@/assets/images/pages/checkout/Office';

export default {
    name: 'CustomSelect',
    components: { CustomSelectItem, House, Flat, Office },
    props: {
        options: {
            type: Array,
            require: true,
        },
        simpleSelect: {
            type: Boolean,
            default: false,
        },
        defaultOption: {
            type: Object,
            default: null,
        },
        trackBy: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            selectedOption: this.defaultOption,
        };
    },
    mounted() {
        this.$emit('input', this.options[this.selectedOption]);
    },
    methods: {
        selectItem(option) {
            this.selectedOption = option;
            this.$emit('input', option);
        },
        getImgUrl(name) {
            return require(`@/assets/images/pages/checkout/${name}`);
        },
        getSelected(option) {
            return this.selectedOption ? this.selectedOption[this.trackBy] === option[this.trackBy] : false;
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-select-simple {
    display: flex;
    margin: 0 auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    &--item {
        width: 30%;
        min-width: 70px;
        border: 1px solid #CECECE;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        &--text {
            font-size: 14px;
            line-height: 35px;
            margin: 0;
        }
        &--image {
            width: 50px;
            height: 50px;
            margin-top: 10px;
        }
        &:hover {
            cursor: pointer;
        }
    }
}
.selected {
    color: #52755C;
}
.selected-border {
    border: 2px solid #52755C;
}
</style>
